
<template>
    <div class="main_table" style="width: 100%">
        <div style="padding-top: 10px; padding-bottom: 10px">
            <span class="title-l1">待审核聚落</span>
        </div>

        <el-table
            :header-cell-style="{
                background: '#eef1f6',
                color: '#606266',
            }"
            class="main_table"
            max-height="48rem"
            :data="currentPageData"
            style="
                margin-top: 0.6rem;
                margin-left: 1.6rem;
                margin-right: 1.6rem !important;
                margin-bottom: 0.6rem;
            "
        >
            <el-table-column
                type="index"
                label="序号"
                width="60"
                :index="indexMethod"
            ></el-table-column>
            <el-table-column
                class="text-body"
                label="聚落名称"
                prop="name"
                width="100"
            ></el-table-column>

            <el-table-column
                class="text-body"
                label="记载方位"
                width="150"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    {{ getRowfang(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column
                class="text-body"
                label="定位时间"
                prop="input_time"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column class="text-body" label="状态" width="100">
                <template slot-scope="scope">
                    <div v-if="scope.row.check_stat == 0" style="color: red">
                        <div
                            style="
                                width: 8px;
                                height: 8px;
                                background: red;
                                border-radius: 50%;
                                display: inline-block;
                            "
                        ></div>
                        待审核
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="scope.row.check_stat == 0"
                        @click="handleCheck(scope.row)"
                        ><span
                            style="
                                font-size: 16px;
                                border: 5px solid #1bc289;
                                background: #1bc289;
                                color: white;
                            "
                            >审核</span
                        ></el-button
                    ></template
                >
            </el-table-column>
        </el-table>
        <div class="pagination_fa_div">
            <el-pagination
                background
                :page-size="pageSize"
                layout="prev, pager, next"
                :page-count="totalCount"
                :current-page.sync="currentPageIndex"
                @current-change="handlePageTurn"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import eventBus from '@/V3/js/eventBus'
export default {
    data() {
        return {
            // 总共有多少条数据
            totalCount: '',
            //
            currentPageData: [],
            // 当前页的分页插件配置
            pageSize: 10,
            totalCount: 0,
            currentPageIndex: 1,
        }
    },
    mounted() {
        this.getBatchData(
            0,
            10,
            'coor_x>0 and coor_y >0 and location_1=0 and check_stat=0'
        )
    },
    methods: {
        indexMethod(index) {
            return (this.currentPageIndex - 1) * this.pageSize + index + 1
        },
        // 拼接方位字段
        getRowfang(value) {
            let res = value.lev2_name 
            if(value.location != null){
                res +=  '，'

            }
            if (value.location != null) {
                res += value.location
            }
            if (value.distance != 0) {
                res += value.distance
                res += '里'
            }
            return res
        },
        // startIndex 从第几条数据开始获取
        // size 获取几条
        // CQL_FILTER 过滤条件
        // 和右边地图的数据点联动
        getBatchData(startIndex, size, CQL_FILTER) {
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                startIndex: startIndex,
                maxFeatures: size,
                CQL_FILTER: CQL_FILTER,
            }
            let self = this
            axios({
                url: $webConfig.V3.owsBaseURL,
                method: 'get',
                params: url_params,
            }).then((res) => {
                self.totalCount = Math.ceil(
                    res.data.totalFeatures / self.pageSize
                )
                let resultTable = []
                res.data.features.forEach((item) => {
                    // 深拷贝
                    // let item = JSON.parse(JSON.stringify(feature))
                    // 过滤数据
                    // 1 待审核 经纬度不为零 and 定位状态 1 and 审核状态 0（待审核
                    if (
                        item.geometry.coordinates[0] != 0 &&
                        item.geometry.coordinates[1] != 0 &&
                        item.properties.location_1 == 0 &&
                        item.properties.check_stat == 0
                    ) {
                        resultTable.push(item.properties)
                    }
                })
                self.currentPageData = resultTable
            })
        },

        // 翻页
        handlePageTurn(val) {
            this.currentPageIndex = val
            // 获取待定位
            this.getBatchData(
                (val - 1) * this.pageSize,
                10,
                'coor_x>0 and coor_y >0 and location_1=0 and check_stat=0'
            )
            eventBus.emit('pageTurn', {
                startIndex: (val - 1) * this.pageSize,
                size: 10,
                CQL_FILTER:
                    'coor_x>0 and coor_y >0 and location_1=0 and check_stat=0',
            })
        },
        // 待审核 开始审核
        handleCheck(value) {
            eventBus.emit('beginCheck', value)
        },
    },
}
</script>
<style scoped>
.main_table >>> .el-table td {
    padding: 14px 0px !important;
}
.main_table >>> .el-table .cell {
    font-size: 18px;
    font-family: '微软雅黑';
}
</style>



// WEBPACK FOOTER //
// src/V3/Main/Check/comLeftTable.vue